import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Modal, Button } from 'antd'

// <Prompt> messages can be a JSON payload with localized texts
// since this modal is rendered by the history instance, outside of the intl provider
const parsePromptMessage = (message) => {
	try {
		const payload = JSON.parse(message)
		if (payload && payload.message) {
			return payload
		}
	} catch (e) {
		// not a JSON payload, display the message as plain text
	}
	return { message }
}

class NavigationConfirmModal extends React.PureComponent {
	state = {
		visible: true
	}

	answer = (allowNavigation) => {
		this.setState({ visible: false })
		this.props.callback(allowNavigation)
	}

	render() {
		const { title, message, leaveText, stayText, afterClose } = this.props
		return (
			<Modal
				destroyOnClose={true}
				visible={this.state.visible}
				title={title}
				maskClosable={false}
				afterClose={afterClose}
				onCancel={() => this.answer(false)}
				footer={[
					<Button
						key="leave"
						danger
						onClick={() => this.answer(true)}
						data-test="navigation-confirm-leave"
					>
						{leaveText || 'Leave'}
					</Button>,
					<Button
						key="stay"
						type="primary"
						onClick={() => this.answer(false)}
						data-test="navigation-confirm-stay"
					>
						{stayText || 'Stay'}
					</Button>
				]}
			>
				{message}
			</Modal>
		)
	}
}

// getUserConfirmation implementation for the history instance
// used by react-router when a <Prompt> blocks an in-app navigation
export const getUserConfirmation = (message, callback) => {
	const payload = parsePromptMessage(message)
	const div = document.createElement('div')
	ReactDOM.render(
		<NavigationConfirmModal
			{...payload}
			callback={callback}
			afterClose={() => {
				ReactDOM.unmountComponentAtNode(div)
			}}
		/>,
		div
	)
}

export default NavigationConfirmModal
